import React from "react";
import "flowbite";
import { BsArrowUpCircle } from "react-icons/bs";
import TextFeild from "./TextFeild";
import { NavLink } from "react-router-dom";

const Modal = () => {
  return (
    <div className="">
      <button
        data-modal-target="defaultModal"
        data-modal-toggle="defaultModal"
        class="block text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        type="button"
      >
        Toggle modal
      </button>

      <div
        id="defaultModal"
        tabindex="-1"
        aria-hidden="true"
        class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] md:h-full"
      >
        <div class="relative w-full h-full max-w-2xl md:h-auto">
          <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
            

            <div class=" ">
              <div className=" ">
              <section class="rounded-3xl shadow-2xl">
                <div class="p-8 text-center sm:p-12">
                    <p class="text-sm font-semibold uppercase tracking-widest text-slate-500">
                        Enter verification Code
                    </p>

                    <h2 class="mt-6 text-2xl font-bold">
                        Please enter verification code sent to your number
                    </h2>
                    <TextFeild/>


                   <NavLink to={'/completed'}>
                   <a
                        class="mt-8 inline-block w-full rounded-full bg-slate-600 hover:bg-slate-500 py-4 text-sm font-bold text-white shadow-xl"
                        href="#/"
                    >
                        Submit
                    </a>
                   </NavLink>
                </div>
            </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
